import {Box, Tab, css, styled} from '@mui/material';
import {StyledContainerTypes} from './types';

export const StickHeader = styled('div')<StyledContainerTypes>`
	border-bottom: 1px solid ${({theme}) => theme.palette.grey.A100};
	background-color: ${({theme, $background}) => $background ?? theme.palette.background.paper};
	position: sticky;
	z-index: 1;
	top: 0px;
	border-bottom: 1px solid ${({theme}) => theme.palette.action.disabled};
`;

export const StyledTabsContainer = styled(Box)`
	padding: 0 32px;

	& .MuiTabs-flexContainer {
		gap: 20px;
	}

	& .MuiTabs-scrollButtons {
		color: ${({theme}) => theme.palette.action.active};
	}

	& .MuiTabs-scrollButtons.Mui-disabled {
		color: ${({theme}) => theme.palette.action.disabled};
		opacity: 1;
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 0;
	}
`;

interface StyledTabProps {
	$isMobile?: boolean;
}

export const StyledTab = styled(Tab)<StyledTabProps>`
	font-size: 0.9375rem;
	font-weight: 600;
	line-height: 1.7;
	padding: 15px 4px;

	${({$isMobile}) =>
		$isMobile &&
		css`
			padding: 16px;
			min-height: 42px;
		`}
`;
